import { ExperienceTemplate } from 'experience-template-renderer-react';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';

export const splitViewTemplate: ExperienceTemplate = {
  id: 'split-view-large',
  version: '1',
  components: [
    {
      metadata: {
        id: 'LayoutFlex',
      },
      type: 'UitkComponent',
      config: {
        type: 'UitkLayoutFlex',
        direction: 'column',
      },
      children: [
        {
          metadata: {
            id: 'toolbarRegion',
          },
          type: 'ToolbarRegion',
          children: [
            {
              metadata: {
                id: 'playback',
              },
              type: 'Playback',
            },
          ],
        },
        {
          metadata: {
            id: 'resultsWrapper',
          },
          type: 'ResultsWrapper',
          children: [
            {
              metadata: {
                id: 'filterbarColumn',
              },
              type: 'UitkComponent',
              config: {
                type: 'UitkLayoutGridItem',
                colSpan: 1,
              },
              children: [
                {
                  metadata: {
                    id: 'filterbar',
                  },
                  type: 'Filterbar',
                  config: {
                    view: SortAndFiltersViewType.FILTER_BAR,
                  },
                },
              ],
            },
          ],
        },
        {
          metadata: {
            id: 'LayoutFlexMain',
          },
          type: 'UitkComponent',
          config: {
            type: 'UitkLayoutFlex',
          },
          children: [
            {
              metadata: {
                id: 'LayoutFlexItemMain',
              },
              type: 'UitkComponent',
              config: {
                type: 'UitkLayoutFlexItem',
                grow: 1,
              },
              children: [
                {
                  metadata: {
                    id: 'mainRegion',
                  },
                  type: 'MainRegion',
                  children: [
                    {
                      metadata: {
                        id: 'resultsWrapper',
                      },
                      type: 'ResultsWrapper',
                      children: [
                        {
                          metadata: {
                            id: 'resultsColumn',
                          },
                          type: 'UitkComponent',
                          config: {
                            type: 'UitkLayoutGridItem',
                            colSpan: 3,
                          },
                          children: [
                            {
                              metadata: {
                                id: 'customerNotificationsAfterHeader',
                              },
                              type: 'CustomerNotificationTemplateComponent',
                              config: {
                                location: CustomerNotificationLocation.AFTER_HEADER,
                              },
                            },
                            {
                              metadata: {
                                id: 'search-results',
                              },
                              type: 'SearchResultsWrapper',
                            },
                          ],
                        },
                        {
                          metadata: {
                            id: 'mapViewColumn',
                          },
                          type: 'UitkComponent',
                          config: {
                            type: 'UitkLayoutGridItem',
                            colSpan: 1,
                          },
                          children: [
                            {
                              metadata: {
                                id: 'MapView',
                              },
                              type: 'MapView',
                              config: {
                                view: SortAndFiltersViewType.FILTER_BAR,
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      metadata: {
                        id: 'customerNotificationsFooter',
                      },
                      type: 'CustomerNotificationTemplateComponent',
                      config: {
                        location: CustomerNotificationLocation.FOOTER,
                      },
                    },
                    {
                      metadata: {
                        id: 'loyaltyEducationDialog',
                      },
                      type: 'LoyaltyEducationDialog',
                    },
                    {
                      metadata: {
                        id: 'delayedSortAndFilterFetchExperiment',
                      },
                      type: 'DelayedSortAndFilterFetchExperiment',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
